<template>
  <div v-if="!(selectedRatings.length > 0 && !compatibilityLevel) || isRankingItemShortcode" 
       :id="isRankingItemShortcode
       ? ('legalny-' + bookieData.name.toLowerCase() + '-' + selectedRatings[0].toLowerCase())
       : ('legalny-' + bookieData.name.toLowerCase())" 
       class="relative bg-zt-normal border border-zt-light rounded-zt w-full"
       :class="{ 'xl:min-w-[862px]' : isBookmakerRankingPage || isNewBookmakersPage }">
    <bookmaker-rating-modal v-if="isModalOpen" 
                            @open-modal="openModal"
                            @close-modal="closeModal"
                            :selectedItemName="selectedItemName"
                            :bookmakerName="bookieData.name"
                            :isBookieAllRatingsModal="isBookieAllRatingsModal"
                            :filteredSelectedRatings="filteredSelectedRatings" />
	  <BonusDetailsModal v-if="isInfoModalOpen"
	                     :class="{ 'xl:absolute xl:left-1/4' : isBookmakerRankingPage }"
	                     :selectedBonusData="{}"
	                     :is-main-bonus="true"
	                     :bookieData="bookieData"
	                     @close-modal="closeInfoModal"/>
    <div class="bg-zt-dark rounded-t-zt">
      <div class="relative flex border-b-0 border-zt-light flex-col-reverse items-center
             xl:items-start xl:flex-row xl:mr-0 xl:h-[128px] xl:pt-4 xl:border-b">
        <div v-if="index">
          <span v-if="selectedRatingsToShow.length === 0 || isFunctionalityRanking"
                class="font-medium bg-zt-light/35 h-[36px] w-[43px] text-[22px] border border-l-0 border-zt-light
                       rounded-r-[10px] absolute left-0 top-[14px] flex justify-center items-center xl:top-[30px]
                       xl:relative  xl:text-[22px] xl:leading-[150%]">
            {{ index }}
          </span>
          <div v-else class="flex flex-col cursor-pointer items-center gap-2 mb-[10.5px] ml-1 xl:ml-[9px] xl:mb-0"
               data-bs-trigger="manual" data-bs-toggle="tooltip" data-bs-container="body" data-bs-placement="bottom"
               data-bs-html="true"
               title='<div class="text-center">Dopasowanie obliczane jest na podstawie wybranych przez Ciebie funkcjonalności</div>'
               @click="openTooltip($event)">
	          <img class="h-[30px] w-[47px] xl:mt-5" :src="compatibilityImageSrc" alt="" />
	          <span class="text-xs font-semibold uppercase xl:normal-case xl:font-medium">Dopasowanie</span>
          </div>
        </div>
        <div class="rounded-b-xl overflow-hidden h-[67px] w-[132px] mb-[14px] ml-1.5
               xl:absolute xl:h-[96px] xl:w-[157px] xl:ml-0 xl:translate-x-0 xl:rounded-zt"
             :class="[
              index ? 'xl:left-[100px]' : 'xl:left-[35px]',
              { 'cursor-pointer zt-hover' : shouldRedirect }
             ]"
             @click="redirectToPromoPage(promoUrl, shouldRedirect)">
          <div class="w-full bg-cover rounded-b-zt -translate-y-1.5 h-[79px] xl:h-[96px] xl:translate-y-0"
               :style="{ backgroundImage: `url('/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${bookieData.name.toLowerCase()}.svg')` }"></div>
        </div>
        <div v-if="window.size.desktop" class="absolute left-1/2 -translate-x-1/2 mt-[13px] flex flex-col items-center"
             :class="{ '!mt-[2px]' : bookieData?.bonus_amount_old !== '' }">
          <span v-if="bookieData?.bonus_amount_old !== ''" class="text-base font-normal text-center opacity-70 line-through">
						{{ bookieData.bonus_amount_old }}
					</span>
          <div class="flex items-center gap-1 text-[40px] font-bold xl:text-[30px]">
            <span class="truncate max-w-[327px]">{{ bookieData.amount }}</span>
          </div>
          <span class="font-medium uppercase text-center opacity-70 truncate max-w-[282px]">
            {{ bookieData.amount_title }}
          </span>
        </div>
        <div v-if="window.size.desktop" class="ml-auto flex gap-y-2 -mt-[1px] flex-col mr-4 xl:w-[252px]">
          <button class="w-[252px] h-[44px] text-sm font-semibold zt-hover bg-zt-red rounded-zt"
                  @click="handleClick(bookieData.link, '_blank')">
            ODBIERZ BONUS
          </button>
	        <button class="no-default-style zt-hover cursor-pointer py-3 px-4 rounded-zt uppercase text-sm font-semibold
								  w-[252px] text-center border border-zt-light"
	                @click="openInfoModal()">Szczegóły bonusu</button>
        </div>
      </div>
    </div>
	  <div v-if="selectedRatingsToShow.length > 0 && !isFunctionalityRanking" class="only-mobile w-full bg-zt-dark px-6">
		  <hr class="border-t border-zt-light border-dashed w-full">
	  </div>
    <div>
      <div class="bg-zt-dark rounded-b-zt px-[11px] pt-[14px] pb-[18px] xl:pb-4 xl:pt-3"
           :class="{ 'xl:px-[103px]': index }">
        <div v-if="selectedRatingsToShow.length > 0">
          <span class="flex justify-center mb-2.5 text-zt-more text-sm">
            {{ isBookmakerRankingPage ? 'WYBRANE:' : 'WYBRANE FUNKCJONALNOŚCI:' }}
          </span>
          <div class="flex flex-col gap-y-2.5 pb-4 xl:flex-row xl:justify-center xl:gap-x-[42px] xl:flex-wrap">
            <template v-for="item in selectedRatingsToShow" :key="item.name">
              <bookmaker-rating-item :item="item"
                                     :bookmakerName="bookieData.name"
                                     @click="handleRatingClick"
                                     :isSelectedRating="true"
                                     :isBookieRankingItem="true"
                                     :isRankingItemShortcode="isRankingItemShortcode"
                                     @open-modal="openModal"/>
            </template>
          </div>
        </div>
        <div v-if="!(selectedRatingsToShow.length > 0 && !areAllRatingsShown)">
          <span v-if="filteredSelectedRatings.length > 0" class="flex justify-center mb-2.5 text-zt-more text-sm">
            POZOSTAŁE:
          </span>
          <span v-else class="flex justify-center mb-2.5 text-zt-more text-sm">MOCNE STRONY:</span>
          <div class="flex flex-col gap-y-2.5 pb-4 xl:flex-row xl:justify-center xl:gap-x-[42px] xl:flex-wrap">
            <template v-for="item in ratingsToShow" :key="item.name" >
              <bookmaker-rating-item :item="item"
                                     @click="handleRatingClick"
                                     :bookmakerName="bookieData.name"
                                     :isBookieRankingItem="true"
                                     :isRankingItemShortcode="isRankingItemShortcode"
                                     @open-modal="openModal"/>
            </template>
          </div>
        </div>
        <div v-if="window.size.mobile || (selectedRatingsToShow.length > 0 && !areAllRatingsShown)" 
             class="flex items-center justify-center gap-1.5 zt-hover cursor-pointer"
             @click="handleRatingClick();countClicks('Ranking bukmacherów [funkcjonalności+rozwiń+wyświetl wszystkie]');
               window.size.mobile ? openModal() : ratingsNumber = filteredRatings.length">
          <button class="underline text-zt-more text-sm">ROZWIŃ POZOSTAŁE</button>
          <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="rotate-90">
            <path d="M3.14286 4.37654L0.156284 7.34468C0.0984555 7.40215 -6.06749e-09 7.36119 -9.63126e-09 7.27966L-6.31312e-08 6.05573C-6.42423e-08 6.03031 0.0105551 6.00603 0.0291442 5.98869L2.29816 3.87243C2.30409 3.8669 2.31355 3.87269 2.31131 3.88049C2.30875 3.88941 2.29561 3.88756 2.29561 3.87829L2.29561 3.78825C2.29561 3.77867 2.30923 3.77686 2.31173 3.7861C2.31389 3.79408 2.30425 3.79988 2.29821 3.79424L0.0290691 1.67312C0.0105253 1.65578 -2.56519e-07 1.63154 -2.57628e-07 1.60615L-3.10919e-07 0.387004C-3.14483e-07 0.305475 0.0984552 0.264514 0.156283 0.321986L3.14286 3.29012L3.60531 3.7697C3.63955 3.80521 3.63955 3.86145 3.60531 3.89696L3.14286 4.37654Z" fill="#93A3BA"/>
          </svg>
        </div>
        <div v-else-if="!areAllRatingsShown"
             class="flex items-center justify-center gap-1.5 zt-hover cursor-pointer"
             @click="handleRatingClick();ratingsNumber = ratingsNumber = filteredRatings.length; countClicks('Ranking bukmacherów [funkcjonalności+rozwiń+wyświetl wszystkie]')">
          <button class="underline text-zt-more text-sm">ROZWIŃ POZOSTAŁE</button>
          <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.12346 3.14286L0.155319 0.156284C0.0978478 0.0984555 0.138808 0 0.220338 0H1.44427C1.46969 0 1.49397 0.0105552 1.51131 0.0291443L3.62757 2.29816C3.6331 2.30409 3.62731 2.31355 3.61951 2.31131C3.61059 2.30875 3.61244 2.29561 3.62171 2.29561H3.71175C3.72133 2.29561 3.72314 2.30923 3.7139 2.31173C3.70592 2.31389 3.70012 2.30425 3.70576 2.29821L5.82688 0.0290693C5.84422 0.0105256 5.86846 0 5.89385 0H7.113C7.19453 0 7.23549 0.0984555 7.17801 0.156284L4.20988 3.14286L3.7303 3.60531C3.69479 3.63955 3.63855 3.63955 3.60304 3.60531L3.12346 3.14286Z" fill="#93A3BA"/>
          </svg>
        </div>
      </div>
      <div v-if="window.size.mobile" class="relative flex flex-col items-center bg-zt-dark rounded-b-zt">
        <div class="w-full px-6">
	        <hr class="border-t border-zt-light border-dashed w-full">
        </div>
        <div class="z-10 flex flex-col items-center w-full pt-4">
	         <span v-if="bookieData?.bonus_amount_old !== ''"
                 class="text-base font-normal text-center opacity-70 line-through">
						{{ bookieData.bonus_amount_old }}
					</span>
          <div class=" text-[30px] font-bold max-w-[90%]">
            <span class="truncate">{{ bookieData.amount }}</span>
          </div>
          <span class="font-medium opacity-70 uppercase text-center truncate max-w-[80%]">
            {{ bookieData.amount_title }}
          </span>
        </div>
	      <div v-if="!isFunctionalityRanking" class="flex mt-6 flex-col mb-4 items-center gap-1">
		      <span class="text-xs text-white/70">Kod promocyjny</span>
		      <div class="relative w-[252px] h-[45px] bg-white rounded-zt border border-dashed border-black
                   cursor-pointer zt-hover"
		           @click="copyToClipBoard()">
              <span class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-xl font-bold text-black">
                {{ bookieData.code }}
              </span>
			      <div class="h-8 w-8 absolute top-2.5 right-3 bg-cover
                     bg-[url(/wp-content/themes/zawodtyper/assets/images/ikona_kopiowanie.svg)]"></div>
		      </div>
	      </div>
        <div class="relative z-10 mb-6 w-[252px]" :class="{ 'mt-6' : isFunctionalityRanking }">
          <button class="w-[252px] h-[44px] text-sm font-semibold zt-hover bg-zt-red rounded-zt"
                  @click="handleClick(bookieData.link,'_blank')">
            ODBIERZ BONUS
          </button>
	        <button class="no-default-style zt-hover cursor-pointer py-3 px-4 rounded-zt uppercase text-sm font-semibold
								  w-[252px] mt-[14px] text-center border border-zt-light"
	                @click="openInfoModal()">Szczegóły bonusu</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';
import BookmakerRatingItem from './BookmakerRatingItem.vue';
import BookmakerRatingModal from './modals/BookmakerRatingModal.vue';
import BonusDetailsModal from "./modals/BonusDetailsModal.vue";
import {countClicks} from "../../assets/js/utils";
import {Notice} from "../../assets/js/Notice";

export default {
  name: 'BookmakersRankingItem',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
	  BonusDetailsModal,
    BookmakerRatingItem,
    BookmakerRatingModal,
  },
  props: {
    bookieData: Object,
    index: Number,
    selectedRatings: Object,
    isFunctionalityRanking: Boolean,
    isRankingItemShortcode: Boolean,
	  analyticNo: Number,
  },
  data() {
    return {
      filteredRatings: [],
      filteredSelectedRatings: [],
      ratingsNumber: 4,
      isModalOpen: false,
      selectedItemName: '',
      isBookieAllRatingsModal: false,
      promoUrl: '',
	    isInfoModalOpen: false,
    };
  },
  mounted() {
    if (this.bookieData.name) {
      this.promoUrl = this.getBookiePromoLink(this.bookieData.name);
    }
    setTimeout(this.refreshTooltips, 300);
  },
  watch: {
    selectedRatings: {
      handler(newSelectedRatings) {
        if (newSelectedRatings.length === 0) {
          this.ratingsNumber = 4;
        }
      },
      deep: true
    }
  },
  computed: {
    ratingsToShow() {
      this.filteredRatings = Object.values(this.bookieData.ratings)
        .filter(rating => rating.value && rating.value !== false && rating.value !== '0')
        .filter(rating => {
          return !this.filteredSelectedRatings.some(selectedRating => selectedRating.name.toLowerCase() === rating.name.toLowerCase());
        })
        .sort((a, b) => {
          const aValue = typeof a.value === 'boolean' && a.value ? 11 : Number(a.value);
          const bValue = typeof b.value === 'boolean' && b.value ? 11 : Number(b.value);

          if (aValue === bValue) {
            return Number(b.priority) - Number(a.priority);
          } else {
            return bValue - aValue;
          }
      });

      return this.filteredRatings.slice(0, window.size.mobile ? 3 : this.ratingsNumber);
    },
    selectedRatingsToShow() {
      this.filteredSelectedRatings = Object.values(this.bookieData.ratings)
        .filter((rating) => this.selectedRatings.includes(rating.name.toLowerCase()))
        .sort((a, b) => {
          const aValue = typeof a.value === 'boolean' && a.value ? 11 : Number(a.value);
          const bValue = typeof b.value === 'boolean' && b.value ? 11 : Number(b.value);

          if (aValue === bValue) {
            return Number(b.priority) - Number(a.priority);
          } else {
            return bValue - aValue;
          }
      });

      return this.filteredSelectedRatings;
    },
    compatibilityLevel() {
      const allSelectedRatings = Object.values(this.bookieData.ratings).filter((rating) => {
        return this.selectedRatings.includes(rating.name.toLowerCase());
      });

      const sumOfValues = allSelectedRatings.reduce((total, rating) => {
        const ratingValue = rating.value !== null && rating.value !== false
        ? (typeof rating.value === 'boolean' && rating.value ? 11 : Number(rating.value))
        : 0;
        return total + ratingValue;
      }, 0);

      const newCompatibilityLevel = (allSelectedRatings.length > 0 ? (sumOfValues / allSelectedRatings.length).toFixed(2) : 0);

      this.$emit('compatibility-level-changed', newCompatibilityLevel);

      return Number(newCompatibilityLevel);
    },
    compatibilityImageSrc() {
      if (this.compatibilityLevel >= 7) {
        return '/wp-content/themes/zawodtyper/assets/images/dopasowania_buki/dopasowanie-wysokie.svg';
      } else if (this.compatibilityLevel > 4) {
        return '/wp-content/themes/zawodtyper/assets/images/dopasowania_buki/dopasowanie-srednie.svg';
      } else {
        return '/wp-content/themes/zawodtyper/assets/images/dopasowania_buki/dopasowanie-niskie.svg';
      }
    },
    areAllRatingsShown() {
      return this.filteredRatings.length <= this.ratingsNumber;
    },
    isBookmakerRankingPage() {
      return this.WP.id === 36;
    },
    isNewBookmakersPage() {
      return this.WP.id === 36436;
    },
    shouldRedirect() {
      return this.promoUrl !== window.location.pathname;
    },
  },
  methods: {
	  copyToClipBoard() {
		  if (window.size.mobile) {
			  navigator.clipboard.writeText(this.code);
			  this.addInternalNotification(new Notice().setContent('Skopiowano kod promocyjny'));
			  this.countClicks('Analityka bez depozytu - SKOPIUJ TYPERVIP');
		  }
	  },
	  openInfoModal() {
		  this.isInfoModalOpen = true;
		  this.blockScrolling();
		  const elementId = this.isRankingItemShortcode
			  ? ('legalny-' + this.bookieData.name.toLowerCase() + '-' + this.selectedRatings[0].toLowerCase())
			  : ('legalny-' + this.bookieData.name.toLowerCase())

		  const targetElement = document.getElementById(elementId);
		  const menuElement = document.getElementById('main-header');

		  if (targetElement) {
			  let offset = menuElement.clientHeight + 21; // top menu offset
			  if (this.isUserWithAdminPanel) {
				  offset += 32; // additional offset for admin panel
			  }

			  const elementTopPosition = targetElement.getBoundingClientRect().top;
			  const offsetPosition = elementTopPosition - offset;

			  window.scrollBy({top: offsetPosition, behavior: 'smooth'});

				if (this.analyticNo) {
					countClicks(`Analityka PODSTRON II rzędu - ${this.analyticNo}C`);
				}
			  if (this.WP.id === 36) {
				  countClicks('Ranking vs Bez Depozytu - Ranking');
			  }
		  }
	  },
	  closeInfoModal() {
		  this.isInfoModalOpen = false;
		  this.unblockScrolling();
	  },
    openModal(itemName) {
      this.isModalOpen = true;
      this.isBookieAllRatingsModal = false;
      this.blockScrolling();

      if (itemName) {
        this.selectedItemName = itemName;

        const elementId = this.isRankingItemShortcode 
        ? ('legalny-' + this.bookieData.name.toLowerCase() + '-' + this.selectedRatings[0].toLowerCase())
        : ('legalny-' + this.bookieData.name.toLowerCase())

        const targetElement = document.getElementById(elementId);
        const menuElement = document.getElementById('main-header');

        if (targetElement) {
          let offset = menuElement.clientHeight + 21; // top menu offset
          if (this.isUserWithAdminPanel) {
            offset += 32; // additional offset for admin panel
          }

          const elementTopPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementTopPosition - offset;

          window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
        }
      } else {
        this.isBookieAllRatingsModal = true;
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.unblockScrolling();
    },
    handleClick(link, target) {
      if (this.WP.id === 34051) {
        countClicks('Podstrony II rzędu - aplikacja');
      } else if (this.WP.id === 30178) {
        countClicks('Podstrony II rzędu - urodzinowe');
      } else if (this.isBookmakerRankingPage) {
        countClicks('Legalny - ODBIERZ BONUS').then(() => {
	        countClicks('Ranking vs Bez Depozytu - Ranking');
        });
      }
	    if (this.analyticNo) {
		    countClicks(`Analityka PODSTRON II rzędu - ${this.analyticNo}B`);
	    }
      axios.post(WP.ajaxUrl, {
        endpoint: 'api_count_outerlink_click',
        link: link,
      });
      window.open(link, target);
    },
	  handleRatingClick() {
		  if (this.analyticNo) {
			  countClicks(`Analityka PODSTRON II rzędu - ${this.analyticNo}A`);
		  }
	  },
    openTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.show();
                setTimeout(() => { 
                  tooltip.hide();
                }, 4000);
              }, 0);
              return;
            }
          }
        }
      }
    }
  }
};
</script>